import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

class NewsSlider {
  private app: HTMLElement;
  private slider: HTMLElement;
  private nextButton: HTMLButtonElement;
  private prevButton: HTMLButtonElement;
  constructor(app: HTMLElement) {
    this.app = app;
    this.slider = this.app.querySelector('.swiper');
    this.nextButton = this.app.querySelector('.swiper-button-next');
    this.prevButton = this.app.querySelector('.swiper-button-prev');

    this.init();
  }

  init(): void {
    new Swiper(this.slider, {
      modules: [A11y, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

document.querySelectorAll('[news-slider]').forEach((newsSlider) => {
  new NewsSlider(newsSlider as HTMLElement);
});
